import { Typography } from '@mui/material';

export const VALUATION_DISCLAIMER_TEXT = "La presente valoración se calcula aplicando metodologías estándar de valoración financiera, académicamente reconocidas y de uso común en la industria. Los resultados constituyen una referencia razonable, no una cotización vinculante ni una certificación: pueden diferir de la valoración de una entidad bancaria o contraparte por diferencias en las fuentes de datos de mercado (curvas, superficies de volatilidad, tasas) o en el momento exacto de su captura. Lumen no actúa como entidad certificadora de valoración.";

export const ValuationDisclaimer = () => (
    <Typography variant="caption" style={{ display: 'block', marginTop: '16px', color: 'var(--text-color-opaque)' }}>
        {VALUATION_DISCLAIMER_TEXT}
    </Typography>
);
